export default {
    login: {
        title: '大圆机管理平台',
        menuTitle: '大圆机管理平台',
        logIn: '登录',
        username: '用户名',
        userHint: '请输入用户名!',
        userInput: '请输入！',
        password: '密码',
        passwordHint: '请输入密码！',
        passwordHint2: '字母+数字+特殊符号 长度不少于8位!',
        passwordHint3: '请再次输入密码!',
        passwordHint4: '字母+数字+特殊符号 长度不少于8位!',
        passwordHint5: '两次密码不匹配',
        loginHint: '还没有账户?马上注册',
        loginSuccess: '登录成功！',
        registerTitle: '注册',
        passwordYes: '确认密码',
        registerHint: '使用已有的账号登录',
        registerSuccess: '注册成功！',
        userInfo: '个人信息',
        logOut: '退出登录'
    },
    router: {
        home: '主页',
        defectRecord: '缺陷记录',
        machine: '机器管理',
        user: '个人中心',
        userSetting: '个人设置',
        export: '导出管理',
        cleanData: '数据清理',
    },
    home: {
        pleaseChoose: '请选择',
        equipment: '设备',
        refresh: '刷新',
        today: '今日',
        week: '本周',
        moth: '本月',
        defectAlarm: '缺陷报警',
        defectCurve: '缺陷曲线',
        defectType: '缺陷类型',
        defectNumber: '缺陷数量',
        defectCountUnit: '个',
        haltCount: '停机次数',
        last7day: '近7天数据',
        eqOverview: '设备数据总览',
        eqDowntime: '设备停机时长',
        updateData: '更新数据',
        defectPercentage: '缺陷占比',
        flaw: '缺陷',
        monday: '星期一',
        tuesday: '星期二',
        wednesday: '星期三',
        thursday: '星期四',
        friday: '星期五',
        saturday: '星期六',
        sunday: '星期天',
        deviceInfo: '设备信息',
        rpm: '转速',
        next: '次',
        defectShutdown: '缺陷停机',
        mean: '平均值',
        generalShutdown: "普通停机",
        totalDefects: '缺陷总数',
        nonstopDefect: '不停机缺陷',
        shutdownDefect: '停机缺陷',
        downtimeDuration: '停机时长',
        runningTime: '运行时长',
        hour: "小时",
    },
    defectRecord: {
        project: '所属项目',
        snCode: 'SN码',
        deviceName: '设备名称',
        data: '日期',
        defectCause: '缺陷原因',
        inquire: '查询',
        reset: '重置',
        derive: '导出',
        deviceSnCode: '设备SN码',
        cameraNumber: '摄像机编号',
        proNumber: '生产编号',
        operatorId: '工人编号',
        writeTime: '记录时间',
        row: '操作',
        success: '请求成功！',
        total: '共',
        strip: '条',
        viewsImg: '查看图片',
        noImg: '暂无图片',
        closeImg: '关闭',
        views: '查看',
        pageTheWarning: '已经是第一张了！',
        pageNextWarning: '已经是最后一张了！',
        importExcel: '导出为Excel',
        stopStatus: '停机状态',
        noStop: '不停机',
        yesStop: '停机',
    },
    machine: {
        address: '地址',
        machineNo: '机台号',
        revolution: '转速',
        signalStrength: '信号强度',
        noMachineInfo: '暂无机器信息'
    },
    account: {
        basicSetup: '基本设置',
        changePassword: '修改密码',
        nickName: '昵称',
        gender: '性别',
        mal: '男',
        female: '女',
        mobile: '手机号',
        mailBox: '邮箱',
        address: '地址',
        updateBasic: '更新基本信息',
        avatar: '头像',
        changeAvatar: '更换头像',
        success: '修改成功！',
        warning: '图像大小限制1MB!',
        rawPassword: '原密码',
        newPassword: '新密码',
        affirmPassword: '确认密码',
        confirmChange: '确认修改',
        hint: '提示',
        status: '状态',
        deletedText: '删除成功！',
        inExport: '导出中',
        offStocks: '已完成',
        defeated: '失败',
        sum: '总数',
        startTime: '开始时间',
        endTime: '结束时间',
        download: '下载',
        delete: '删除',
        exporting: '正在导出',
    }
}